import {subscribeUserToWebNotifications} from "./InitWebPushNotification";

export const enablePushNotifications = () => {
  if (Notification.permission !== "denied" && Notification.permission !== "granted") {
        Notification.requestPermission().then((permission) => {
            if (permission === "granted") {
                subscribeUserToWebNotifications();
            }
        });
    }
}
export const reloadPushNotifications = () => {
    if (Notification.permission === "granted") {
        subscribeUserToWebNotifications()
    }
}

